import {
  READ_ORDER_REQUESTED,
  READ_ORDER_SUCCESS,
  READ_ORDER_FAILURE,
  CREATE_FULFILLMENT_REQUESTED,
  CREATE_FULFILLMENT_SUCCESS,
  CREATE_FULFILLMENT_FAILURE,
  CLEAR_ORDER,
  SET_CHECKED_LIST,
  SET_UNPICKABLE_LIST,
  CLEAR_ORDER_ACTIONS,
  // UPDATE_LINE_ITEM_QUANTITY_REQUESTED,
  // UPDATE_LINE_ITEM_QUANTITY_SUCCESS,
  // UPDATE_LINE_ITEM_QUANTITY_FAILURE,
} from '../types';


const INITIAL_STATE = {
  isFetching: false,
  fulfillments: [],
  fulfillmentLocations: [],
  checkedItems: [],
  unpickableItems: [],
  status: 'waiting',
  orderId: null,
  orderGid: null,
  orderStatuses: [],
  orderNote: null,
  fulfillmentStatus: null,
  alertId: null,
  orderFulfillmentFetching: false,
  orderFulfillmentMessage: null,
  orderSetQuantityFetching: false,
  orderSetQuantityMessage: null,
  orderFulfillmentStatus: null,
  errors: null
};


const pickOrder = (state = INITIAL_STATE, action) => {
  const newState = { ...state };

  switch(action.type) {
    case READ_ORDER_REQUESTED:
      newState.isFetching = true;
      newState.status = 'requesting';
      newState.fulfillments = [];
      newState.fulfillmentLocations = [];
      newState.checkedItems = [];
      newState.unpickableItems = [];
      newState.orderFulfillmentStatus = null;
      return newState;

    case READ_ORDER_SUCCESS:
      newState.isFetching = false;
      newState.status = action.payload.error ? 'failure' : 'success';
      newState.orderId = action.payload.order.order_id;
      newState.orderGid = action.payload.order.order_gid;
      newState.fulfillments = action.payload.order.fulfillments;
      newState.fulfillmentLocations = action.payload.order.fulfillment_locations;
      newState.fulfillmentStatus = action.payload.order.status_id;
      newState.orderNote = action.payload.order.order_note;
      newState.errors = action.payload.error;
      newState.orderFulfillmentStatus = action.payload.order.order_status;
      return newState;

    case READ_ORDER_FAILURE:
      newState.isFetching = false;
      newState.errors = action.error;
      newState.status = 'failure';
      return newState;

    case SET_CHECKED_LIST:
      newState.checkedItems = action.checkedList;
      return newState;

    case SET_UNPICKABLE_LIST:
      newState.unpickableItems = action.unpickableList;
      return newState;


    case CLEAR_ORDER:
      newState.isFetching = false;
      newState.fulfillments = [];
      newState.fulfillmentLocations = [];
      newState.checkedItems = [];
      newState.unpickableItems = [];
      newState.status = 'waiting';
      newState.orderId = null;
      newState.fulfillmentStatus = null;
      newState.errors = null;
      newState.orderFulfillmentMessage = null;
      newState.orderFulfillmentStatus = null;
      return newState;

    case CLEAR_ORDER_ACTIONS:
      newState.orderFulfillmentMessage = null;
      return newState;

    default:
      return state;
  }
}

export default pickOrder;
